export default "__VITE_ASSET__BSV0s_mm__"